import type { UseFormRegister } from 'react-hook-form';
import { Card, CardBody, Eyebrow } from '@/shared/components';
import { I } from '@/shared/icons';
import type { PropertyValues } from './schema';

interface ChannexSectionProps {
  register: UseFormRegister<PropertyValues>;
}

export function ChannexSection({ register }: ChannexSectionProps) {
  return (
    <Card>
      <CardBody className="p-6">
        <Eyebrow variant="muted" className="mb-4">
          Kanalmanager
        </Eyebrow>
        <label className="border-line bg-card-alt/40 flex cursor-pointer items-start gap-3 rounded-md border p-3">
          <input
            type="checkbox"
            className="accent-sage mt-0.5 size-4"
            {...register('autoProvisionToChannex')}
          />
          <span className="flex-1">
            <span className="text-ink flex items-center gap-2 text-sm font-medium">
              <I name="Webhook" size={14} aria-hidden />
              Direkt für die Buchungsportale vorbereiten
            </span>
            <span className="text-ink-soft mt-1 block text-xs">
              Das Apartment wird nach dem Speichern beim Kanalmanager angelegt. Erst danach lassen
              sich Preise und Verfügbarkeit übertragen und Buchungsportale verbinden. Schlägt das
              fehl, bleibt das Apartment in StayOn bestehen — der Versuch lässt sich auf der
              Detailseite wiederholen.
            </span>
          </span>
        </label>
      </CardBody>
    </Card>
  );
}
